"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelStyles = void 0;
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
// #region consts
const DATA_QUALITY_TEXT_AREA_HEIGHT = 100;
const DATA_QUALITY_DIALOG_TEST_ID = 'data-quality-dialog';
const MESSAGE_MAXIMUM_LENGTH = 4000;
const DATA_QUALITY_DIALOG_MESSAGE_ID = DATA_QUALITY_DIALOG_TEST_ID + '-message';
const DROPDOWN_WIDTH = 200;
const POPOVER_WIDTH = 400;
const ICON_SIZE = 18;
const iconStyle = {
    float: 'left',
    marginRight: '4px',
    width: '18px',
    height: '18px',
};
const INFO_ICON_SIZE = 16;
const infoIconStyle = {
    float: 'right',
};
const ContentItemNameDiv = (0, vizportalclient_common_components_1.divWithStyle)(`${DATA_QUALITY_DIALOG_TEST_ID}-content-item-name-text`, {
    marginTop: '16px',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Large,
    color: widgets_1.TabStyles.Typography.Color.Primary,
    display: 'inline',
});
const DropDownPromptDiv = (0, vizportalclient_common_components_1.divWithStyle)(`${DATA_QUALITY_DIALOG_TEST_ID}-dropdown-prompt-text`, {
    paddingTop: widgets_1.TabStyles.Spacing.MediumSpace,
});
const dropDownStyle = {
    width: DROPDOWN_WIDTH,
    marginTop: '2px',
};
const textAreaStyle = {
    height: DATA_QUALITY_TEXT_AREA_HEIGHT,
    resize: 'none',
};
const markupEditorStyle = {
    marginBottom: '27px',
    marginTop: '36px',
};
const textAreaWidgetClass = textAreaCssClass(DATA_QUALITY_DIALOG_MESSAGE_ID);
const checkboxStyle = {
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
};
const SpaceHeader = {
    minWidth: 0,
    color: '#666666',
    fontSize: '14px',
};
const visibilityTextStyle = {
    paddingRight: '4px',
};
// #endregion
exports.LabelStyles = Object.freeze({
    MESSAGE_MAXIMUM_LENGTH,
    POPOVER_WIDTH,
    INFO_ICON_SIZE,
    ICON_SIZE,
    iconStyle,
    infoIconStyle,
    ContentItemNameDiv,
    DropDownPromptDiv,
    dropDownStyle,
    textAreaStyle,
    markupEditorStyle,
    textAreaWidgetClass,
    checkboxStyle,
    SpaceHeader,
    visibilityTextStyle,
    helpTextDiv,
    textAreaCssClass,
});
function textAreaCssClass(testId) {
    return (0, vizportalclient_common_components_1.cssClass)(`${testId}-text-area`, {
        fontWeight: 'normal',
        boxSizing: 'border-box',
        width: '100%',
        fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
        outline: 'none',
        marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    });
}
function helpTextDiv(testId) {
    return (0, vizportalclient_common_components_1.divWithStyle)(`${testId}-help-text`, {
        paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    });
}
//# sourceMappingURL=LabelStyles.js.map